<template lang="pug">
  .box
    .header
      h1
        img(src="../assets/img/logo.png" alt="")
      .nav
        ul
          li
            a(href="javascript:;" @click="goHome" :class="[this.$store.state.flag==1?'bdBlue':'']") 网站首页
          li
            a(href="javascript:;" @click="goProduct" :class="[this.$store.state.flag==2?'bdBlue':'']") 业务产品
          li
            a(href="javascript:;" @click="goSlution" :class="[this.$store.state.flag==4?'bdBlue':'']") 解决方案
          li
            a(href="javascript:;" @click="goCase" :class="[this.$store.state.flag==3?'bdBlue':'']") 成功案例
          li
            a(href="javascript:;" @click="goNews" :class="[this.$store.state.flag==5?'bdBlue':'']") 新闻资讯
          li
            a(href="javascript:;" @click="goContact" :class="[this.$store.state.flag==6?'bdBlue':'']") 客户服务
          li
            a(href="javascript:;" @click="goWe" :class="[this.$store.state.flag==7?'bdBlue':'']") 关于我们
      //.icon
        .erweibox
          <i class="iconfont iconweixin"></i>
          .erweima
            img(src="../assets/img/erweima.png" alt="")
    .banner
    .title
      h3 速云招聘
      .line
    .recruitBody
      .recruitTab
        ul
          //li(style="border-left:1px solid #ccc;" :class="[flag==1?'bcWhite':'']" @click="flag=1") 全国区域
          li(style="border-left:1px solid #ccc;" :class="[flag==1?'bcWhite':'']" @click="flag=1") 兰州地区
      .recruitData
        //.explain 全国地区包含：深圳、杭州、广州、北京、上海、南京、苏州、济南、郑州、青岛、西安、武汉、长沙、成都、重庆、昆明、厦门、福州、佛山
        .recruitNav
          a(v-for="item in navs" :key="item.id" :href="item.id") {{item.name}}
        .details
          a(name="01")
          p.one 阿里巴巴钉钉部署专家
          p <strong>岗位职责</strong>
          p 1）负责阿里巴巴旗下钉钉产品的线下市场推广工作；
          p 2）熟悉钉钉使用操作流程，对政府、教育、医疗等各行业进行培训，帮助企业深度运用；
          p 3）根据企业的信息化需求，制定企业钉钉使用方案，协助企业在其内部推行使用；
          p 4）深入挖掘企业信息化需求，推荐定制化信息服务，助力企业全面完成数字化转型。
          <br/>
          p <strong>任职要求</strong>
          p 1）本科及以上学历，优秀者可放宽至大专；
          p 2）计算机相关专业、软件相关专业、经管相关专业优先；
          p 3）计算机操作熟练，有一定的网络知识基础，熟练使用Photoshop等制图工具者优先考虑；
          p 4）熟悉办公室行政管理知识及工作流程，熟悉方案、公文写作格式，具备基本商务信函写作能力；
          p 5）性格要求沉稳、隐忍，善于倾听，有同理心，乐观、积极；普通话标准、流利，反应灵敏；具有自我发展的主观愿望和自我学习能力；
          p 6）具备软件及网络方案撰写能力和较强的沟通协调以及语言表达能力，有一定客户服务工作经验，有一定的客户服务知识和能力。
          <br/>
          <hr/>
        .details
          a(name="02")
          p.one 文案策划
          p <strong>岗位职责</strong>
          p 1）针对公司产品撰写推广文案(公司信息及公司动态新闻的编辑)；
          p 2）根据业务人员的描述，充分掌握客户需求点，提供有价值的策划理念和推广传播概念点；
          p 3）负责公司相关新闻报道的文字撰稿，以便网站更新维护管理；
          p 4）负责客户宣传性软文的撰稿、组稿、编辑工作；
          p 5）配合公司市场部，做好营销策划案以及可行性报告；
          p 6）参与配合公司其他部门的工作，完成主管及上级领导交给其他临时性工作。
          <br/>
          p <strong>任职要求</strong>
          p 1）本科及以上学历，优秀者可放宽至大专；
          p 2）计算机相关专业、软件相关专业、经管相关专业优先；
          p 3）计算机操作熟练，有一定的网络知识基础，熟练使用Photoshop等制图工具者优先考虑；
          p 4）熟悉办公室行政管理知识及工作流程，熟悉方案、公文写作格式，具备基本商务信函写作能力；
          p 5）性格要求沉稳、隐忍，善于倾听，有同理心，乐观、积极；普通话标准、流利，反应灵敏；具有自我发展的主观愿望和自我学习能力；
          p 6）具备软件及网络方案撰写能力和较强的沟通协调以及语言表达能力，有一定客户服务工作经验，有一定的客户服务知识和能力。
          <br/>
          <hr/>
        .details
          a(name="03")
          p.one 客服专员
          p <strong>岗位职责</strong>
          p 1）受理及主动电话客户，能够及时发现客户问题并给到正确和满意的回复；
          p 2）与客户建立良好的联系，熟悉及挖掘客户需求，并对客户进行系统的应用培训；
          p 3）具备处理问题、安排进展、跟进进程、沟通及疑难问题服务的意识跟能力，最大限度的提高客户满意度。遇到不能解决的问题按流程提交相关人员或主管处理，并跟踪进展直至解决；
          p 4）针对公司现有的客户进行营销，让客户接受更为广泛的网络产品，达到最好的网络营销的效果；
          p 5）不断接受公司的各项业务和技能提升培训。
          <br/>
          p <strong>任职要求</strong>
          p 1）本科及以上学历，优秀者可放宽至大专；
          p 2）计算机相关专业、软件相关专业、经管相关专业优先；
          p 3）计算机操作熟练，有一定的网络知识基础，熟练使用Photoshop等制图工具者优先考虑；
          p 4）熟悉办公室行政管理知识及工作流程，熟悉方案、公文写作格式，具备基本商务信函写作能力；
          p 5）性格要求沉稳、隐忍，善于倾听，有同理心，乐观、积极；普通话标准、流利，反应灵敏；具有自我发展的主观愿望和自我学习能力；
          p 6）具备软件及网络方案撰写能力和较强的沟通协调以及语言表达能力，有一定客户服务工作经验，有一定的客户服务知识和能力。
          <br/>
          <hr/>
        .details
          a(name="04")
          p.one 软件工程师
          p <strong>岗位职责</strong>
          p 1）独立地设计、开发、实现和测试关键应用系统；
          p 2）将作为团队骨干理解业务问题、分析系统需求并编写需求规范；
          p 3）有能力对一个应用模块或子系统进行架构设计；
          p 4）配合进行软件产品的需求定义、设计，BUG的修改；
          p 5）负责软件的测试计划和优化、设计文档编写、测试分析报告；
          p 6）为现有系统和客户提供技术支持和维护；
          <br/>
          p <strong>任职要求</strong>
          p 1）本科及以上学历，优秀者可放宽至大专；
          p 2）计算机相关专业、软件相关专业、经管相关专业优先；
          p 3）计算机操作熟练，有一定的网络知识基础，熟练使用Photoshop等制图工具者优先考虑；
          p 4）熟悉办公室行政管理知识及工作流程，熟悉方案、公文写作格式，具备基本商务信函写作能力；
          p 5）性格要求沉稳、隐忍，善于倾听，有同理心，乐观、积极；普通话标准、流利，反应灵敏；具有自我发展的主观愿望和自我学习能力；
          p 6）具备软件及网络方案撰写能力和较强的沟通协调以及语言表达能力，有一定客户服务工作经验，有一定的客户服务知识和能力。
          <br/>
          <hr/>
        .details
          a(name="05")
          p.one 技术支持、维护
          p <strong>岗位职责</strong>
          p 1）做好用户的送货及设备安装调试工作；
          p 2）做好安装调试记录，包括产品标识性信息、用户的详细信息及相关人员信息；
          p 3）对公司售出产品进行售后服务和维修，在一个工作日内响应客户的服务需求，及时到达客户地点并快速解决故障；如不能现场完成的应当与客户协商好后续的维修工作。
          <br/>
          p <strong>任职要求</strong>
          p 1）本科及以上学历，优秀者可放宽至大专；
          p 2）计算机相关专业、软件相关专业、经管相关专业优先；
          p 3）计算机操作熟练，有一定的网络知识基础，熟练使用Photoshop等制图工具者优先考虑；
          p 4）熟悉办公室行政管理知识及工作流程，熟悉方案、公文写作格式，具备基本商务信函写作能力；
          p 5）性格要求沉稳、隐忍，善于倾听，有同理心，乐观、积极；普通话标准、流利，反应灵敏；具有自我发展的主观愿望和自我学习能力；
          p 6）具备软件及网络方案撰写能力和较强的沟通协调以及语言表达能力，有一定客户服务工作经验，有一定的客户服务知识和能力。
          <br/>
          <hr/>
        .details
          a(name="06")
          p.one 人事行政
          p <strong>岗位职责</strong>
          p 1）协助和处理人事日常事务；
          p 2）负责监管执行各项人事制度，并向主管汇报；
          p 3）指导人事，后勤文员起草人事部文件；
          p 4）各类信息收集并及时提供给主管，做好会议记录与资料整理归档工作；
          p 5）建立并查阅新进员工个人资料，制度各部培训计划，并主导实施；
          p 6）部门文具及日用品的申购，主管缺席时临时替代主管工作；
          p 7）承办主管临时交待各项事宜；
          p 8）熟悉人力资源六大板块，负责人员入转调离及各项合同、协议签订。
          <br/>
          p <strong>任职要求</strong>
          p 1）本科及以上学历，优秀者可放宽至大专；
          p 2）计算机相关专业、软件相关专业、经管相关专业优先；
          p 3）计算机操作熟练，有一定的网络知识基础，熟练使用Photoshop等制图工具者优先考虑；
          p 4）熟悉办公室行政管理知识及工作流程，熟悉方案、公文写作格式，具备基本商务信函写作能力；
          p 5）性格要求沉稳、隐忍，善于倾听，有同理心，乐观、积极；普通话标准、流利，反应灵敏；具有自我发展的主观愿望和自我学习能力；
          p 6）具备软件及网络方案撰写能力和较强的沟通协调以及语言表达能力，有一定客户服务工作经验，有一定的客户服务知识和能力。
          <br/>
      .contact <strong>联系人：</strong>江女士 <strong style="margin-left:30px;">邮箱：</strong>1749121344@qq.com <strong style="margin-left:30px;">联系电话：</strong>13919966697 / 8896007
    .footer
      .footerLeft
        img(src="../assets/img/logobai.png" alt="")
        ul
          li
            //p 咨询电话：<span>0931-0000000</span>
          li
            //p 咨询电话：<span>0931-0000000</span>
          li
            p 咨询电话：<span>400-0931-866</span>
          li 隐私声明 | 版权所有 © 速云软件 2001-2020 备注号 陇ICP备18000095号-1
      .footerRight
        .barCode
          img(src="../assets/img/weibo.png" alt="")
          h5 官方微博
        .barCode
          img(src="../assets/img/gongzhong.jpg" alt="")
          h5 官方公众号
        .barCode
          img(src="../assets/img/toutiao.jpg" alt="")
          h5 官方头条
</template>

<script>
export default {
  data () {
    return {
      flag: 1,
      navs: [
        {
          name: '阿里巴巴钉钉部署专家',
          id: '#01'
        },
        {
          name: '文案策划',
          id: '#02'
        },
        {
          name: '客服专员',
          id: '#03'
        },
        {
          name: '软件工程师',
          id: '#04'
        },
        {
          name: '技术支持、维护',
          id: '#05'
        },
        {
          name: '人事行政',
          id: '#06'
        }
      ]
    }
  },
  methods: {
    goWe () {
      window.scroll(0, 0)
      this.$router.push('/we')
    },
    goProduct () {
      window.scroll(0, 0)
      this.$router.push('/product')
    },
    goHome () {
      window.scroll(0, 0)
      this.$router.push('/home')
    },
    goNews () {
      window.scroll(0, 0)
      this.$router.push('/news')
    },
    goSlution () {
      window.scroll(0, 0)
      this.$router.push('/slution')
    },
    goContact () {
      window.scroll(0, 0)
      this.$router.push('/contact')
    },
    goCase () {
      window.scroll(0, 0)
      this.$router.push('/case')
    }
  },
  mounted () {
    document.title = '速云招聘'
  }
}
</script>

<style lang="less" scoped>
  .box{
    width: 100%;
    .header{
      width: 100%;
      height: 14vh;
      background-color: #fff;
      box-shadow: 1px 1px 4px rgba(0, 0, 0, .3);
      h1{
        float: left;
        margin: 4vh 0 0 8vw;
        img{
          width: 11vw;
        }
      }
      .nav{
        ul{
          float: left;
          margin: 4vh 0 0 20vw;
          li{
            float: left;
            padding: 0 20px;
            a{
              display: inline-block;
              height: 44px;
              line-height: 44px;
            }
            a:hover{
              border-bottom: 3px solid #409fee;
            }
          }
        }
      }
      // .icon{
      //   position: relative;
      //   float: left;
      //   margin-top: 25px;
      //   height: 44px;
      //   line-height: 44px;
      //   .erweibox{
      //     float: left;
      //   }
      //   .iconweixin{
      //     margin-right: 20px;
      //     cursor: pointer;
      //   }
      //   .erweibox:hover{
      //     .erweima{
      //       display: block;
      //     }
      //   }
      //   .iconxingtaiduICON_sousuo--{
      //     cursor: pointer;
      //   }
      //   .erweima{
      //     position: absolute;
      //     display: none;
      //     bottom: -170px;
      //     left: -105px;
      //     width: 120px;
      //     height: 120px;
      //     padding: 20px;
      //     border-radius: 10px;
      //     background-color: #fff;
      //     border: 1px solid #ccc;
      //     z-index: 9999;
      //     img{
      //       width: 100%;
      //       height: 100%;
      //     }
      //   }
      //   .erweima::before{
      //     content: "";
      //     position: absolute;
      //     top: -11px;
      //     right: 35px;
      //     width: 20px;
      //     height: 20px;
      //     transform: rotate(45deg);
      //     border-top: 1px solid #ccc;
      //     border-left: 1px solid #ccc;
      //     background-color: #fff;
      //   }
      // }
    }
    .banner{
      width: 100%;
      height: 386px;
      background-image: url(../assets/img/bannerZP.jpg);
      background-size: cover;
      background-position: 50%;
    }
    .title{
      padding: 30px 0;
      h3{
        font-size: 34px;
        text-align: center;
        font-weight: 400;
      }
      .line{
        width: 50px;
        height: 3px;
        background-color: #00f6f9;
        margin: 15px auto 0;
      }
    }
    .recruitBody{
      padding: 0 103px;
      .recruitTab{
        ul{
          height: 40px;
          li{
            float: left;
            height: 40px;
            line-height: 40px;
            width: 150px;
            background-color: #ddd;
            text-align: center;
            border-top: 1px solid #ccc;
            border-right: 1px solid #ccc;
            cursor: pointer;
          }
        }
      }
      .recruitData{
        border: 1px solid #ccc;
        padding: 30px 40px;
        font-size: 14px;
        .explain{
          margin: 10px auto 40px;
          padding: 10px 30px;
          background: #f4f4f4;
          border: 1px solid #dfdfdf;
        }
        .recruitNav{
          margin: 20px auto 40px;
          padding-bottom: 40px;
          border-bottom: 1px solid #e8e8e8;
          a{
            display: inline-block;
            width: 200px;
            height: 35px;
            line-height: 34px;
            text-align: center;
            margin-right: 10px;
            border: 1px solid #ccc;
            border-radius: 50px;
            margin-bottom: 10px;
            cursor: pointer;
          }
          a:hover{
            background-color: #e8e8e8;
          }
        }
        .details{
          .one{
            margin-bottom: 5px;
            color: #006ec3;
            font-size: 16px;
          }
          p{
            font-size: 14px;
            line-height: 26px;
            color: #555;
          }
          hr{
            border-top: 1px solid #eeeeee;
          }
        }
      }
      .contact{
        margin: 40px auto;
        font-size: 14px;
      }
    }
    .footer{
      width: 100%;
      height: 240px;
      background-color: #20242B;
      .footerLeft{
        float: left;
        margin-left: 12%;
        padding-top: 52px;
        img{
          width: 156px;
          height: 39px;
        }
        li{
          margin-top: 22px;
          font-size: 14px;
          color: #fff;
          p{
            font-size: 16px;
            span{
              color: #017CF8;
            }
          }
        }
      }
      .footerRight{
        float: right;
        margin-right: 12%;
        margin-top: 52px;
        .barCode{
          display: inline-block;
          width: 136px;
          height: 180px;
          background-color: #fff;
          margin-left: 42px;
          img{
            display: inline-block;
            width: 122px;
            height: 122px;
            margin: 7px;
            vertical-align: middle;
          }
          h5{
            width: 136px;
            height: 44px;
            font-weight: 400;
            background-color: #007BF9;
            line-height: 44px;
            text-align: center;
          }
        }
      }
    }
    .bcWhite{
      background-color: #fff!important;
      border-bottom: 1px solid #fff;
      margin-bottom: -1px;
    }
    .bdBlue{
      border-bottom: 3px solid #409fee;
    }
  }
</style>
